import { render, staticRenderFns } from "./supervision.vue?vue&type=template&id=dded1756&scoped=true"
import script from "./supervision.vue?vue&type=script&lang=js"
export * from "./supervision.vue?vue&type=script&lang=js"
import style0 from "./supervision.vue?vue&type=style&index=0&id=dded1756&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dded1756",
  null
  
)

export default component.exports